<template>
  <div class="login-wrap">
    <div class="login-text">
      <div class="text">
        <Login></Login>
      </div>
    </div>
  </div>
</template>

<script>
import Login from './login.vue'

export default {
  components: {
    Login
  },
  data() {
    return {
      qrcodeUrl: '',
      // : require('@/assets/img/mobile-logo.png'),
      appVersion: '',
      loginIs: true
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
.login-wrap {
  display: flex;
  width: 100%;
  height: 100%;

  .login-text {
    position: relative;
    width: 100%;
    background: url('../../assets/img/login-bg.png') no-repeat center;
    background-size: 100% 100%;

    .text {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -350px 0 0 -310px;
      width: 680px;
      height: 390px;
      font-family: "SourceHanSansCN";

      .img {
        width: 156px;
        height: 74px;
        background: url('../../assets/img/login-logo.png') no-repeat center;
        background-size: 100% 100%;
      }

      h2 {
        padding: 8px 0 24px;
        color: #32B768;
        font-size: 60px;
        font-weight: 500;
        text-shadow: 3px 3px 0 rgba(67, 207, 124, 0.3);
      }

      .info {
        padding-bottom: 24px;

        p {
          color: #32B768;
          font-size: 20px;
        }
      }

    }

    .qrcode-panel {
      position: absolute;
      left: 50%;
      bottom: 10%;
      margin-left: -310px;
      width: 186px;
      padding: 29px 0 16px;
      background: #fff;
      border-radius: 8px;
      text-align: center;

      .qrcode-img {
        display: block;
        margin: 0 auto;
      }

      h2 {
        padding: 25px 0 12px;
        color: #32B768;
        font-size: 14px;
        line-height: 1;
        font-weight: 500;
      }

      p {
        color: #D9DDDE;
        font-size: 12px;
      }
    }
  }

  .login-panel {
    position: relative;
    width: 40%;
  }
}
</style>
